import React, { useState } from 'react';
import { useI18nContext, Trans } from '@ecg-marktplaats/js-react-i18n';
import { SegmentedControl, TextRegular, StandAloneLink } from '@hz-design-system/web-ui';

import { trackGAEvent } from '../../../utils/gaTracking';

import Classes from './CarsSearchFormToggleGroup.scss';
import { TFacet } from 'types/TCarsSearchFields';

type TCarsSearchFormToggleGroupProps = {
  fieldKey: string;
  formField: TFacet;
  values?: string[];
  onChangeHandler: Function;
};

let BasicModal;

const CarsSearchFormToggleGroup = ({
  formField,
  fieldKey,
  values,
  onChangeHandler,
}: TCarsSearchFormToggleGroupProps) => {
  const { t } = useI18nContext();
  const [leaseModalOpen, setLeaseModalOpen] = useState(false);

  const leaseInfoOnClick = async () => {
    trackGAEvent('priceTypeTooltipClicked');
    try {
      BasicModal = (await import(/* webpackChunkName: "BasicModal" */ '@hz-design-system/web-ui')).BasicModal;
      setLeaseModalOpen(!leaseModalOpen);
    } catch {}
  };

  if (!formField?.options?.length) {
    return null;
  }

  const selectedValue =
    !values || values[0] === '' || !values.length || values.length === formField?.attributeGroup?.length
      ? ''
      : values[0];

  const handleChange = (value: string) => {
    onChangeHandler(fieldKey, value, formField?.type, true);
  };

  const options = [
    { value: '', label: t('cars.search.options.all') },
    ...formField.options.map((option) => ({
      value: option.value.toString(),
      label: t(`cars.search.options.${option.value}`, option.label),
    })),
  ];

  return (
    <div className="FormField FormField--toggleGroup">
      <div className={`FormField-Label ${Classes.label}`}>
        <TextRegular color="text-primary" strong>
          {formField?.label}
        </TextRegular>
        <StandAloneLink onClick={leaseInfoOnClick}>{t('cars.search.more_info_button')}</StandAloneLink>
      </div>
      <SegmentedControl value={selectedValue} onChange={handleChange} options={options} aria-label={formField?.label} />
      {leaseModalOpen && (
        <BasicModal
          size="m"
          title={t('cars.search.pricetype.modal_title')}
          className="PriceTypeModal"
          onClose={() => setLeaseModalOpen(false)}
        >
          <Trans
            i18nKey="cars.search.pricetype.modal"
            paragraph-open={Trans.safeString('<p>')}
            paragraph-close={Trans.safeString('</p>')}
            title-open={Trans.safeString('<h5>')}
            title-close={Trans.safeString('</h5>')}
            bold-open={Trans.safeString('<div class="hz-Text hz-Text--bodyLargeStrong">')}
            bold-close={Trans.safeString('</div>')}
            list-open={Trans.safeString('<ul>')}
            list-close={Trans.safeString('</ul>')}
            list-item-open={Trans.safeString('<li>')}
            list-item-close={Trans.safeString('</li>')}
            break={Trans.safeString('<br>')}
          />
        </BasicModal>
      )}
    </div>
  );
};

export default CarsSearchFormToggleGroup;
